var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard flex flex-col xl:flex-row justify-between w-full py-4 md:px-12 md:py-16"},[_c('dashboard-data',{class:{ 'pr-6': _vm.userType === 'admin' && _vm.$mq === 'xl' }}),(_vm.userType === 'admin')?_c('projects-overview-module',{staticClass:"xl:pl-6 pt-1 md:pt-0 md:max-w-xs xl:mt-0",class:{
      'mt-6': !(_vm.userType === 'admin' && _vm.$mq === 'sm')
    }}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }